import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import commonNetwork from "../../../common/api/commonNetwork";
import { RootStateType } from "../../../store/RootState";
import MaterailTable, { HeadCellType } from "../Elements/MaterialTable"; 

interface RecordTableProps {
    getHeadCells: (values: any) => void;
    reportTableRef: any;
}

const RecordTable: React.FC<RecordTableProps> = ({ getHeadCells, reportTableRef }) => {

    const { cronJobRecordList, isFetching, } = useSelector((state: RootStateType) => state.cronJobRecordList);

    useEffect(() => {
        getHeadCells(headCells)
    }, [])


    const headCells: Array<HeadCellType> = [

        {
            id: 'id',
            numeric: false,
            label: 'ID',
            isprimary: true,
            className: "min-w-[50px]",
            colWidth: 10, // For excel
            hide: true,
            exceptToExcel: true
        },
        {
            id: 'cronType',
            numeric: true,
            label: 'Görev Tipi',
            className: "min-w-[50px]",
            maxLength: 15,
            colWidth: 20, // For excel
        },
        {
            id: 'startDate',
            numeric: true,
            label: 'Başlangıç Tarihi',
            className: "min-w-[100px]",
            colWidth: 20, // For excel
        },
        {
            id: 'endDate',
            numeric: false,
            label: 'Bitiş Tarihi',
            colWidth: 20, // For excel
            className: "min-w-[110px]",
        },
        {
            id: 'result',
            numeric: false,
            label: 'İşlem Detayı',
            className: "max-w-[300px]",
            colWidth: 30, // For excel
        },

    ];

    return (
        <div className="w-full">



            <MaterailTable ref={reportTableRef} headerCells={headCells}
                tableData={cronJobRecordList}
                isRowSelect={true} isLoading={isFetching}
                emptyMessage={isFetching === false ? "Verilen kritere uygun kayıt bulunamamıştır" : ""}
            ></MaterailTable>

        </div>
    );
}
export default RecordTable;